import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";

export const ShareModal = ({
  isShareModal,
  setIsShareModal,
  handleSubmitDocument,
  providerData,
  setDocuments,
  documents,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [selectedFileNames, setSelectedFileNames] = useState([]);
  const [selectedTypes, setSelectedTypes] = useState([]);

  useEffect(() => {
    if (
      !providerData.recommendationsfile &&
      !providerData.cv &&
      !providerData.qualificationscertificatesdoc &&
      (!providerData.backgrounddoc ||
        (providerData.backgrounddoc &&
          providerData.backgrounddoc_deleted_at === 1))
    ) {
      navigate("/search-providers/my-document?return=1");
    }
  }, [navigate, providerData]);

  useEffect(() => {
    // Sinhronizuj selekciju sa documents
    setSelectedFileNames(documents.map((doc) => doc.name));
  }, [documents]);

  async function fetchFileAsFileObject(filename) {
    const fileUrl = `${window.location.origin}/assets/images/users/${filename}`;
    const response = await fetch(fileUrl);
    if (!response.ok) {
      throw new Error("Failed to fetch file from server");
    }
    const blob = await response.blob();
    return new File([blob], filename, { type: blob.type });
  }

  const handleToggleFile = async (serverFileName, originalFileName, docType) => {
    const isSelected = selectedTypes.includes(docType);

    if (isSelected) {
      setSelectedTypes(prev => prev.filter(type => type !== docType));
      setDocuments(prev => prev.filter(doc => doc._docType !== docType));
    } else {
      setSelectedTypes(prev => [...prev, docType]);
      try {
        const fileObject = await fetchFileAsFileObject(serverFileName);
        fileObject._docType = docType;
        setDocuments(prev => [...prev, fileObject]);
      } catch (error) {
        console.error("Error fetching file:", error);
        setSelectedTypes(prev => prev.filter(type => type !== docType));
      }
    }
  };


  const buildDocumentObject = () => {
    const docObject = {};

    documents.forEach(file => {
      if (file._docType) {
        docObject[file._docType] = file;
      }
    });

    return docObject;
  };

  return (
    <Modal show={isShareModal} onHide={() => setIsShareModal(false)}>
      <Modal.Body>
        <div className="promocode_content share_profile">
          <br />
          <div className="list_prorofile">
            <ul>
              {providerData.recommendationsfile &&
                providerData.recommendationsfile_deleted_at === 0 && (
                  <li>
                    <img
                      src={window.location.origin + "/images/team.svg"}
                      alt="recommendation"
                    />
                    <p>
                      {t("text-recommendation") + "_"}
                      {providerData.recommendationsfile_original
                        ? providerData.recommendationsfile_original.substr(0, 20)
                        : ""}
                    </p>
                    <input
                      type="checkbox"
                      name="document"
                      checked={selectedTypes.includes("recommendationsfile")}
                      onChange={() =>
                        handleToggleFile(
                          providerData.recommendationsfile,
                          providerData.recommendationsfile_original,
                          "recommendationsfile"
                        )
                      }
                    />
                  </li>
                )}

              {providerData.cv && providerData.cv_deleted_at === 0 && (
                <li>
                  <img
                    src={window.location.origin + "/images/team.svg"}
                    alt="cv"
                  />
                  <p>
                    {t("text-cv-underline")}
                    {providerData.cv_original
                      ? providerData.cv_original.substr(0, 20)
                      : ""}
                  </p>
                  <input
                    type="checkbox"
                    name="document"
                    checked={selectedTypes.includes("cv")}
                    onChange={() =>
                      handleToggleFile(
                        providerData.cv,
                        providerData.cv_original,
                        "cv"
                      )
                    }
                  />
                </li>
              )}

              {providerData.qualificationscertificatesdoc &&
                providerData.qualificationscertificatesdoc_deleted_at === 0 && (
                  <li>
                    <img
                      src={window.location.origin + "/images/team.svg"}
                      alt="certificate"
                    />
                    <p>
                      {t("text-certificate") + "_"}
                      {providerData.qualificationscertificatesdoc_original
                        ? providerData.qualificationscertificatesdoc_original.substr(
                          0,
                          20
                        )
                        : ""}
                    </p>
                    <input
                      type="checkbox"
                      name="document"
                      checked={selectedTypes.includes("qualificationscertificatesdoc")}
                      onChange={() =>
                        handleToggleFile(
                          providerData.qualificationscertificatesdoc,
                          providerData.qualificationscertificatesdoc_original,
                          "qualificationscertificatesdoc"
                        )
                      }
                    />
                  </li>
                )}

              {providerData.backgrounddoc &&
                providerData.backgrounddoc_deleted_at === 0 && (
                  <li>
                    <img
                      src={window.location.origin + "/images/team.svg"}
                      alt="background"
                    />
                    <p>
                      {t("text-background") + "_"}
                      {providerData.backgrounddoc_original
                        ? providerData.backgrounddoc_original.substr(0, 20)
                        : ""}
                    </p>
                    <input
                      type="checkbox"
                      name="document"
                      checked={selectedTypes.includes("backgrounddoc")}
                      onChange={() =>
                        handleToggleFile(
                          providerData.backgrounddoc,
                          providerData.backgrounddoc_original,
                          "backgrounddoc"
                        )
                      }
                    />
                  </li>
                )}
            </ul>

            <button onClick={() => setIsShareModal(false)}>
              {t("text-cancel")}
            </button>
            <button
              onClick={async () => {
                try {
                  const documentObj = buildDocumentObject();
                  await handleSubmitDocument(documentObj);
                  setIsShareModal(false);
                } catch (error) {
                  alert("Error sending document: " + error.message);
                }
              }}
            >
              {t("text-submit")}
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
